import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ModuleDetails } from 'app/pages/Create/Modules/Module/Settings';
import { searchRequest } from 'core/services/product';
import { LoadingState } from 'types/domain/base';
import { ISearch, ISearchResponse, SearchType, SortBy } from 'types/domain/search';
import { IAuthResponse } from 'types/session/auth';

export interface ISearchReducer {
  term: string;
  filter: number;
  sort: SortBy | number;
  response: ISearchResponse;
  loading: LoadingState;
  searchType: SearchType;
  selected: ISearchSelection[];
}

export interface ISearchSelection {
  moduleId: number;
  actionId: number;
  index: number;
  created: number;
}

const initialState: ISearchReducer = {
  term: null,
  filter: null,
  sort: SortBy.MODIFIED,
  response: null,
  loading: LoadingState.DEFAULT,
  searchType: null,
  selected: [],
};

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    updateSearch(state, action: PayloadAction<ISearch>) {
      return { ...state, ...action.payload, response: null };
    },
    selectSearchResult(state, action: PayloadAction<ISearchSelection>) {
      state.selected.push(action.payload);
    },
  },
  extraReducers: builder => {
    builder
      .addCase(searchRequest.pending, (state, action: any) => {
        state.loading = LoadingState.LOADING;
      })
      .addCase(searchRequest.rejected, (state, action: any) => {
        state.loading = LoadingState.ERROR;
      })
      .addCase(searchRequest.fulfilled, (state, action: PayloadAction<IAuthResponse>) => {
        state.loading = LoadingState.LOADED;
        state.response = action.payload.searchResponse;
      });
  },
});

export const { updateSearch, selectSearchResult } = searchSlice.actions;

export default searchSlice.reducer;
